import React from "react";
import { IndianRupee, Wrench, Zap, Clock, ShieldCheck, Bike } from "lucide-react";
import { features } from "../mock/mock";

const iconMap = { IndianRupee, Wrench, Zap, Clock };

const Features = () => {
  return (
    <section id="about" className="py-20 lg:py-28 bg-neutral-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Intro */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
          <div className="relative">
            <img
              src="https://images.unsplash.com/photo-1776021808492-e7a7de58c580?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxtb3BlZCUyMGNvYXN0YWx8ZW58MHx8fHwxNzg1ODEyNDg4fDA&ixlib=rb-4.1.0&q=85"
              alt="Self drive scooty rental in Udupi and Manipal by RR Bros"
              loading="lazy"
              decoding="async"
              className="w-full h-[420px] object-cover rounded-2xl shadow-xl"
            />
            <div className="hidden md:block absolute -bottom-6 -right-6 bg-white rounded-xl shadow-xl p-5 border border-neutral-100 max-w-[240px]">
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 rounded-full bg-orange-100 flex items-center justify-center">
                  <ShieldCheck className="w-6 h-6 text-orange-600" />
                </div>
                <div>
                  <p className="text-xs text-neutral-500 font-medium">Two branches</p>
                  <p className="font-black text-neutral-900 text-lg">Udupi &amp; Manipal</p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <span className="text-orange-600 font-bold text-sm uppercase tracking-[0.2em]">
              About Us
            </span>
            <h2 className="mt-3 text-4xl sm:text-5xl font-black text-neutral-900 leading-[1.1] tracking-tight">
              Why Rent a Bike in <span className="text-orange-500">Udupi &amp; Manipal</span> from RR Bros?
            </h2>
            <p className="mt-6 text-neutral-600 text-base sm:text-lg leading-relaxed">
              RR Bros is the most trusted choice for bike rental in Udupi and
              scooty rental in Manipal. Get affordable rates with flexible km
              plans. Rent a scooter from our fleet of Honda Activa 6G, Yamaha
              Fascino 125 and Yamaha Ray-Z.
            </p>
            <p className="mt-4 text-neutral-600 leading-relaxed">
              Whether you're a student in Manipal, a tourist exploring the temples of
              Udupi, or a local heading around town, we have the right ride for you.
            </p>
            <a
              href="#bikes"
              className="inline-flex items-center gap-2 mt-8 px-6 py-3 bg-neutral-900 hover:bg-orange-500 text-white font-bold text-sm uppercase tracking-wider rounded-full transition-colors"
            >
              <Bike className="w-4 h-4" />
              View Our Fleet
            </a>
          </div>
        </div>

        {/* Feature cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((f, idx) => {
            const Icon = iconMap[f.icon] || Bike;
            return (
              <div
                key={idx}
                className="group bg-white rounded-2xl p-7 border border-neutral-100 hover:border-orange-200 hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
              >
                <div className="w-14 h-14 rounded-2xl bg-orange-50 group-hover:bg-orange-500 flex items-center justify-center mb-5 transition-colors">
                  <Icon className="w-7 h-7 text-orange-500 group-hover:text-white transition-colors" />
                </div>
                <h3 className="font-black text-xl text-neutral-900 mb-2">{f.title}</h3>
                <p className="text-neutral-600 text-sm leading-relaxed">{f.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
